import { format } from "date-fns";
import { cs } from "date-fns/locale";

/**
 * Date helper for testing achievement resets and formatting
 *
 * 🧪 TESTING: Set TEST_DATE to simulate a different date
 * Example: export const TEST_DATE = new Date('2025-11-08T10:00:00Z');
 * Set to null for normal operation
 */
export const TEST_DATE: Date | null = null;
//export const TEST_DATE: Date | null = new Date('2025-11-17T10:00:00Z');

/**
 * Get current date - returns TEST_DATE if set, otherwise real current date
 */
let hasLoggedTestMode = false;
export function getCurrentDate(): Date {
  if (TEST_DATE && !hasLoggedTestMode) {
    console.log('🧪 TEST MODE: Using simulated date:', TEST_DATE.toISOString());
    hasLoggedTestMode = true;
  }
  return TEST_DATE || new Date();
}

/**
 * Get today's date string in YYYY-MM-DD format
 */
export function getTodayString(): string {
  return getCurrentDate().toISOString().split('T')[0];
}

/**
 * Format an ISO date string for display (e.g. due dates): "d. M. yyyy." with Czech locale.
 * Returns "" for invalid or unparseable input.
 */
export function formatDueDate(isoDate: string): string {
  try {
    const d = new Date(isoDate);
    if (Number.isNaN(d.getTime())) return "";
    return format(d, "d. M. yyyy.", { locale: cs });
  } catch {
    return "";
  }
}

